import React from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';

import { useLanguage } from '../../contexts/LanguageContext';

/**
 * L'annonce avant un geste irréversible — **écrite une fois, pour tous les
 * écrans qui en ont un.**
 *
 * 🔴 CE QU'ELLE REMPLACE, ET POURQUOI. Le projet comptait **treize
 * `window.confirm`**, et les treize gardaient un geste irréversible :
 * supprimer un utilisateur, un stock, un produit, un fournisseur, une
 * commande, un reçu, un paiement, une entreprise ; annuler une commande ;
 * suspendre un client ; délier un compte Google ; prendre l'identité de
 * quelqu'un. **Un dialogue natif ne sait offrir qu'OK et Annuler**, il ne
 * porte aucune mise en forme, et surtout il ne peut **rien montrer**.
 *
 * 🔴 ET C'EST LE POINT : *« supprimer ce stock » n'apprend rien ; « ce stock
 * porte 12 produits et 4 commandes » décide.* Une confirmation qui se contente
 * de demander « êtes-vous sûr » déplace la responsabilité sans donner de quoi
 * l'exercer — elle fait cliquer, elle ne fait pas choisir.
 *
 * ⚠️ `consequences` EST DONC LE CŒUR, PAS UN ORNEMENT. C'est ce que le geste
 * va emporter, dit avec des chiffres quand on les a. Un appelant qui n'a rien
 * à y mettre devrait se demander s'il connaît vraiment l'effet de son bouton.
 *
 * ⚠️ ET LE BOUTON DE CONFIRMATION NOMME LE GESTE — « Supprimer », « Suspendre »,
 * jamais « OK ». *Un bouton qui dit « OK » fait relire la question ; un bouton
 * qui dit ce qu'il fait se lit seul.*
 */
const DialogueConfirmation = ({
  ouvert, titre, question, consequences, avertissement,
  libelleConfirmer, couleur = 'error', enCours = false, onConfirmer, onFermer,
}) => {
  const { t } = useLanguage();

  return (
    <Dialog open={Boolean(ouvert)} onClose={onFermer} maxWidth="xs" fullWidth>
      <DialogTitle>{titre}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{question}</Typography>

        {/* Ce que le geste emporte. Absent quand il n'emporte rien de
            dénombrable — on ne fabrique pas une conséquence pour meubler. */}
        {consequences && (
          <Typography variant="body2" sx={{ mt: 1.5, fontWeight: 600 }}>
            {consequences}
          </Typography>
        )}

        {/* 🔴 L'AVERTISSEMENT EST UNE SURFACE, PAS UNE PHRASE DE PLUS. Il porte
            ce qui est IRRÉVERSIBLE — et la couleur de texte est celle de la
            sévérité, jamais une couleur écrite à la main (garde Q, RU4-c′). */}
        {avertissement && (
          <Alert severity="warning" sx={{ mt: 2 }}>{avertissement}</Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onFermer} disabled={enCours}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" color={couleur} onClick={onConfirmer}
                disabled={enCours}>
          {libelleConfirmer}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogueConfirmation;
